<div class="chat-panel__messages">
    <div class="chat-output" #chatOutput>
        @if(messages()?.length > 0){
        <div class="chat-thread">
            @for(message of messages(); track message; let i = $index){
            <div class="chat-message" [class.chat-message--user]="message.type === 'USER'">
                <div class="chat-message__text">
                    <phito-markdown [markdown]="message.text"></phito-markdown>
                    @if(message.id && message.type === 'AI'){
                    <div class="one-row">
                        <button mat-icon-button style="transform: scale(0.75);" matTooltip="Gute Antwort"
                            (click)="like(i)">
                            @if(message.like === true){
                            <mat-icon fontIcon="thumb_up"></mat-icon>
                            }@else {
                            <mat-icon fontIcon="thumb_up" style="font-variation-settings: 'FILL' 0;"></mat-icon>
                            }
                        </button>
                        <button mat-icon-button style="transform: scale(0.75);" matTooltip="Schlechte Antwort"
                            (click)="dislike(i)">
                            @if(message.like === false){
                            <mat-icon fontIcon="thumb_down"></mat-icon>
                            }@else {
                            <mat-icon fontIcon="thumb_down" style="font-variation-settings: 'FILL' 0;"></mat-icon>
                            }
                        </button>
                        <button mat-icon-button matTooltip="Kopieren" (click)="copyContent(message)">
                            <mat-icon style="transform: scale(0.75);">
                                content_copy
                            </mat-icon>
                        </button>
                        <button mat-icon-button [disabled]="getSourceCount(message) === 0" matTooltip="Quellen anzeigen"
                            (click)="openSourcesDialog(message)">
                            <mat-icon style="transform: scale(0.75);" [matBadge]="getSourceCount(message)"
                                [matBadgeHidden]="getSourceCount(message) === 0" matBadgeSize="large">
                                source
                            </mat-icon>
                        </button>
                        <span class="spacer"></span>
                        <span style="padding: 0; margin: 0; color: var(--mat-sys-outline-variant); font-size: 0.75rem;">
                            {{message?.createdAt | date:'dd.MM.yy HH:mm'}}</span>
                    </div>
                    }
                </div>
            </div>
            }
        </div>
        }@else{
        <p class="placeholder">Stellen Sie eine Frage, um die Wissensdatenbank zu durchsuchen.</p>
        }
    </div>
    @if(isProcessing()){
    <p class="status status--processing">Antwort wird generiert …</p>
    }
    @if(connectionError()){
    <p class="status status--error">Verbindung zum Chat konnte nicht aufgebaut werden.</p>
    }
    @if(isLoadingMessages()){
    <p class="status status--processing">Unterhaltung wird geladen …</p>
    }
</div>
<div class="chat-panel__input">
    <mat-form-field appearance="outline" class="question-field">
        <button mat-icon-button matSuffix type="button" (click)="submitQuestion()" [disabled]="inputDisabled()">
            <mat-icon>send</mat-icon>
        </button>
        <input matInput placeholder="Frage stellen" [formControl]="questionCtrl" (keyup.enter)="submitQuestion()" />
    </mat-form-field>
</div>